export const accessAllowed = [1, 2, 3, 14, 18, 19, 33, 42, 43, 44, 45, 46];
